/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

/**
 * Checks if 'value' is existy (Not null or undefined).
 *
 * @param {*} value The value to check.
 * @returns {Boolean} True if the 'value' is existy, else false.
 * @example
 *
 * isExisty('Foo');
 * // -> true
 *
 * isExisty(null);
 * // -> false
 *
 * isExisty();
 * // -> false
 */
export const isExisty = (value) => {
  return value != null;
};
